export var CLICK_ACTION_SOURCE = 'Click'; // Action source for when user clicks on suggestion
export var DEFAULT_COLLAPSED_WIDTH = 356;
export var DEFAULT_EXPANDED_WIDTH = 928;
export var END_MATCH_DELIMITER = String.fromCharCode(0xe001); // This char marks end of highlighting
export var END_MATCH_DELIMITER_REGEXP = new RegExp(END_MATCH_DELIMITER, 'g');
export var NONBREAKING_SPACE_CHAR = String.fromCharCode(160);
export var PILL_LIMIT = 2;
export var SPACE_REGEX = /\s/g;
export var START_MATCH_DELIMITER = String.fromCharCode(0xe000); // This char marks start of highlighting
export var START_MATCH_DELIMITER_REGEXP = new RegExp(START_MATCH_DELIMITER, 'g');
//# sourceMappingURL=searchConstants.js.map